import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import RequestListItem from '../../components/retailer/requests/RequestListItem'
import productRequestTypes from '../../constants/productRequestTypes'
import Pagination from '../../components/common/Pagination'
import PageTitle from '../../components/common/PageTitle'
import { MESSAGE_LISTING_REFETCH_INTERVAL_MILLIS } from '../../constants/messagingConstants'

const ProductRequestsPage = () => {
  const [activeFilter, setActiveFilter] = useState()
  const [page, setPage] = useState(1)

  const { data: bidRequestsData } = useQuery({
    queryKey: QueryKeys.retailerBidRequests(activeFilter, page),
    queryFn: () =>
      handleGetRequest('retailer/bid-requests', {
        bidRequestType: activeFilter,
        page,
      }),
    refetchInterval: MESSAGE_LISTING_REFETCH_INTERVAL_MILLIS,
  })

  const bidRequests = bidRequestsData?.data || []

  const renderFilters = () => {
    return Object.values(productRequestTypes).map((type) => (
      <button
        key={type.value}
        onClick={() => {
          setActiveFilter(type.key)
          setPage(1)
        }}
        className={`py-2 px-4 text-sm font-medium ${
          activeFilter === type.key ? 'border-b-2 border-orange-500 text-orange-600' : ''
        }`}
      >
        {type.title}
      </button>
    ))
  }

  return (
    <div className="main-container">
      <PageTitle>Product Requests</PageTitle>

      <div className="flex space-x-2 mb-4 border-b border-gray-200">{renderFilters()}</div>

      <div className="space-y-4">
        {bidRequests.length > 0 ? (
          bidRequests.map((request) => {
            return (
              <RequestListItem
                key={`${request.type}-${request.id}`}
                request={request}
                reloadData={() => {
                  QueryKeys.retailerBidRequests.invalidate(activeFilter, page)
                }}
              />
            )
          })
        ) : (
          <p className="text-center text-gray-500 mt-8">No requests found.</p>
        )}
        <Pagination paginationMeta={bidRequestsData?.meta} onPageChange={(page) => setPage(page)} />
      </div>
    </div>
  )
}

export default ProductRequestsPage
